import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.materials');
import { OnInit, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface DashboardMetric {
    label: string;
    value: string;
    rawValue: number;
    note: string;
    status: string;
    filterKey: string;
}

interface MaterialTypeStat {
    key: string;
    label: string;
    count: number;
    value: string;
    percent: number;
    pending: number;
    publicReady: number;
    basis: string;
}

interface StatusSummaryItem {
    label: string;
    value: string;
    count: number;
    note: string;
    filterKey: string;
}

interface AttentionReason {
    key: string;
    label: string;
    count: number;
    value: string;
    issueCount: number;
    uncheckedCount: number;
    basis: string;
    filterKey: string;
}

interface AttentionSummary {
    uniqueCount: number;
    reasonTotal: number;
    reasons: AttentionReason[];
    note: string;
}

interface RecentMaterialItem {
    id: string;
    title: string;
    author: string;
    publishedYear: number;
    materialType: string;
    reviewStatus: string;
    publicStatus: string;
    pdfCount: number;
    bodyChunkCount: number;
    reasonLabels: string[];
    recordedDate: string;
    sortBasis: string;
}

interface DataBasis {
    label: string;
    source: string;
    actualData: boolean;
    temporaryData: boolean;
    materialCount: number;
    metadataFiles: number;
    pdfFiles: number;
    coverFiles: number;
    processedPdfCount: number;
    pendingPdfCount: number;
    failedPdfCount: number;
    unconfirmedPdfCount: number;
    pdfPageCount: number;
    textPageCount: number;
    ocrRequiredPageCount: number;
    chunkCount: number;
    generatedAt: string;
    reconciliation: any;
    statusDictionary: any[];
    dedupe: any;
    refresh: string;
    unknownDisplay: string;
}

interface OptionItem {
    value: string;
    label: string;
}

interface MaterialListFilters {
    query: string;
    title: string;
    contributor: string;
    materialId: string;
    keyword: string;
    source: string;
    materialType: string;
    accessLevel: string;
    reviewStatus: string;
    fulltext: string;
    registrationMethod: string;
    dashboardState: string;
    formatGroup: string;
    tagAxis: string;
    tagName: string;
    sort: string;
}

interface MaterialListItem {
    id: string;
    title: string;
    materialType: string;
    contributor: string;
    publishedYear: string;
    originalLabel: string;
    originalDetail: string;
    differenceLabels: string[];
    differenceExtraCount: number;
    originalDbStatus: string;
    metadataStatus: string;
    reviewStatus: string;
    publicStatus: string;
    lastModified: string;
    registrationMethod: string;
    detailUrl: string;
    reasonKey?: string;
    reasonLabel?: string;
    reasonCategory?: string;
    reasonBasis?: string;
    reasonSignal?: string;
    reasonSignalLabel?: string;
    reasonStatus?: string;
    reasonStatusLabel?: string;
    reasonFingerprint?: string;
    assignee?: string;
    dueAt?: string;
    requestedAt?: string;
}

@Component({
    selector: 'wiz-page-admin-materials',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.materials/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
}

.materials-page {
  width: min(1320px, 100% - 48px);
  min-height: 100vh;
  margin: 0 auto;
  padding: 20px 0 36px;
  background: var(--design-bg);
  color: var(--design-text);
  font-family: SUIT, Arial, sans-serif;
}

.materials-header,
.access-summary,
.metric-card,
.dashboard-panel,
.data-basis {
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--admin-panel-bg);
  box-shadow: var(--design-shadow);
}

.materials-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
}

.materials-title {
  min-width: 0;
}

.materials-title p,
.materials-title h1,
.materials-title span,
.panel-heading p,
.panel-heading h2,
.type-row p,
.access-summary p {
  margin: 0;
}

.materials-title p,
.panel-heading p,
.panel-heading > span,
.access-summary span,
.metric-card span,
.metric-card em,
.type-meta,
.status-row span,
.data-basis span {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
}

.materials-title h1 {
  margin-top: 6px;
  font-size: 23px;
  font-weight: 850;
  line-height: 1.25;
  letter-spacing: 0;
}

.materials-title span {
  display: block;
  margin-top: 7px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
}

.materials-header nav {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.materials-header a,
.denied-panel a {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 11px;
  background: #ffffff;
  color: var(--design-accent);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.materials-header a:hover,
.materials-header a:focus-visible,
.denied-panel a:hover,
.denied-panel a:focus-visible,
.manage-link:hover,
.manage-link:focus-visible {
  border-color: var(--design-border-strong);
  background: var(--admin-button-secondary-hover);
  box-shadow: var(--design-focus-ring);
}

.materials-header a[href="/admin/materials/new"],
.denied-panel a {
  border-color: var(--admin-button-primary-bg);
  background: var(--admin-button-primary-bg);
  color: var(--design-on-accent);
}

.materials-header a[href="/admin/materials/new"]:hover,
.materials-header a[href="/admin/materials/new"]:focus-visible,
.denied-panel a:hover,
.denied-panel a:focus-visible {
  border-color: var(--admin-button-primary-hover);
  background: var(--admin-button-primary-hover);
}

.access-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 12px 0;
  padding: 12px 16px;
}

.access-summary div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.access-summary strong {
  font-size: 14px;
  font-weight: 850;
}

.access-summary p {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
}

.metric-card {
  min-width: 0;
  padding: 14px;
}

.metric-filter-button,
.type-filter-button {
  width: 100%;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.metric-filter-button:hover,
.metric-filter-button:focus-visible,
.type-filter-button:hover,
.type-filter-button:focus-visible {
  border-color: var(--design-border-strong);
  box-shadow: var(--design-focus-ring);
}

.metric-card strong {
  display: block;
  margin-top: 8px;
  font-size: 25px;
  font-weight: 850;
  line-height: 1.1;
}

.metric-card em {
  display: block;
  margin-top: 8px;
  font-style: normal;
  line-height: 1.35;
}

.status-draft {
  background: #fafafa;
}

.status-review,
.status-approval {
  border-color: var(--design-border-strong);
}

.status-public {
  background: rgba(94, 102, 118, 0.08);
}

.status-internal {
  background: rgba(102, 102, 102, 0.08);
}

.dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);
  gap: 14px;
  margin-top: 12px;
}

.dashboard-panel {
  min-width: 0;
  padding: 16px;
}

.panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.panel-heading h2 {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 850;
  line-height: 1.3;
}

.panel-heading > span {
  white-space: nowrap;
}

.type-list,
.status-list {
  display: grid;
  gap: 10px;
}

.type-row {
  min-width: 0;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px;
  background: var(--design-bg-muted);
}

.type-row-top,
.type-meta,
.status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.type-row-top strong,
.status-row strong {
  min-width: 0;
  font-size: 14px;
  font-weight: 850;
  line-height: 1.35;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.type-row-top span,
.status-row em {
  font-size: 14px;
  font-style: normal;
  font-weight: 850;
  white-space: nowrap;
}

.type-bar {
  height: 8px;
  overflow: hidden;
  margin: 10px 0 8px;
  border-radius: 999px;
  background: #ececec;
}

.type-bar i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #536c7a;
}

.type-meta {
  flex-wrap: wrap;
}

.type-row p {
  margin-top: 7px;
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.status-row {
  border-bottom: 1px solid var(--design-border-soft);
  padding: 11px 0;
}

.status-row:first-child {
  padding-top: 0;
}

.status-row:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.status-row div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.recent-panel {
  margin-top: 12px;
}

.list-panel {
  margin-top: 12px;
}

.list-heading {
  margin-bottom: 14px;
}

.material-search-grid,
.material-filter-grid {
  display: grid;
  gap: 10px;
}

.material-search-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr)) auto;
}

.material-filter-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-top: 10px;
}

.material-search-grid label,
.material-filter-grid label {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.material-search-grid span,
.material-filter-grid span,
.list-basis {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 850;
}

.list-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}

.list-pagination button {
  min-height: 34px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 14px;
  background: #ffffff;
  color: var(--design-text-primary);
  font: inherit;
  font-weight: 800;
}

.list-pagination button:disabled {
  opacity: 0.45;
}

.list-pagination span {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 750;
}

.material-search-grid input,
.material-filter-grid select {
  width: 100%;
  min-height: 38px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 10px;
  background: #ffffff;
  color: var(--design-body-text);
  font-size: 13px;
  font-weight: 750;
  outline: none;
}

.material-search-grid input:focus,
.material-filter-grid select:focus {
  border-color: var(--design-focus-ring-color);
  box-shadow: var(--design-focus-ring);
}

.search-actions {
  display: flex;
  align-items: flex-end;
  gap: 7px;
}

.search-actions button,
.manage-link {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 12px;
  background: var(--design-accent);
  color: var(--design-on-accent);
  cursor: pointer;
  font-size: 13px;
  font-weight: 850;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.search-actions button:hover,
.search-actions button:focus-visible {
  border-color: var(--admin-button-primary-hover);
  background: var(--admin-button-primary-hover);
  box-shadow: var(--design-focus-ring);
}

.search-actions button.secondary,
.manage-link {
  background: #ffffff;
  color: var(--design-accent);
}

.search-actions button.secondary:hover,
.search-actions button.secondary:focus-visible {
  border-color: var(--design-border-strong);
  background: var(--admin-button-secondary-hover);
}

.material-table-scroll {
  margin-top: 12px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
}

.table-scroll {
  overflow-x: auto;
}

.recent-table,
.material-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.recent-table {
  min-width: 860px;
}

.material-table {
  min-width: 1180px;
}

.recent-table th,
.recent-table td,
.material-table th,
.material-table td {
  border-top: 1px solid var(--design-border-soft);
  padding: 12px 10px;
  color: var(--design-body-text);
  font-size: 13px;
  line-height: 1.45;
  text-align: left;
  vertical-align: top;
}

.recent-table th,
.material-table th {
  background: var(--design-bg-muted);
  color: var(--design-text-secondary);
  font-weight: 850;
}

.recent-table td:first-child {
  width: 42%;
}

.recent-table a {
  display: block;
  color: var(--design-accent);
  font-weight: 850;
  text-decoration: none;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.recent-table td:first-child span,
.material-table td:nth-child(2) span {
  display: block;
  margin-top: 4px;
  color: var(--design-text-secondary);
  font-weight: 700;
}

.material-table a:not(.manage-link) {
  color: var(--design-accent);
  font-weight: 850;
  text-decoration: none;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.material-table .id-cell {
  color: var(--design-text-secondary);
  font-weight: 850;
}

.col-id {
  width: 92px;
}

.col-title {
  width: 250px;
}

.col-type {
  width: 104px;
}

.col-contributor {
  width: 142px;
}

.col-year {
  width: 82px;
}

.col-status {
  width: 128px;
}

.col-date {
  width: 104px;
}

.col-action {
  width: 94px;
}

.list-basis {
  margin: 12px 0 0;
  line-height: 1.45;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  border: 1px solid var(--design-border-soft);
  border-radius: 999px;
  padding: 0 8px;
  background: #ffffff;
  color: var(--design-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
  white-space: nowrap;
}

.status-badge.is-pending {
  background: var(--admin-badge-hold-bg);
  color: var(--admin-badge-hold-text);
}

.status-badge.is-muted {
  background: #f7f7f7;
  color: var(--design-text-secondary);
}

.status-badge.is-public {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.status-badge.is-complete {
  background: var(--admin-badge-complete-bg);
  color: var(--admin-badge-complete-text);
}

.status-badge.is-internal {
  background: var(--admin-badge-internal-bg);
  color: var(--admin-badge-internal-text);
}

.status-badge.is-hold,
.status-badge.is-review-pending,
.status-badge.is-draft {
  border-color: rgba(138, 90, 0, 0.2);
  background: var(--admin-badge-hold-bg);
  color: var(--admin-badge-hold-text);
}

.status-badge.is-private {
  background: var(--admin-badge-private-bg);
  color: var(--admin-badge-private-text);
}

.status-badge.is-review-complete {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.empty-cell {
  color: var(--design-text-secondary);
  text-align: center;
}

.data-basis {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-top: 12px;
  padding: 12px 16px;
}

.data-basis strong {
  font-size: 13px;
  font-weight: 850;
}

.data-basis details {
  width: 100%;
  margin-top: 8px;
  border-top: 1px solid var(--design-border-soft);
  padding-top: 10px;
}

.data-basis summary {
  cursor: pointer;
  font-weight: 850;
}

.data-basis details p,
.data-basis details li {
  margin-top: 7px;
  color: var(--design-text-secondary);
  font-size: 12px;
  line-height: 1.5;
}

.notice {
  margin: 14px 0 0;
  font-size: 13px;
  font-weight: 850;
}

.notice.error {
  color: #9a2a2a;
}

.denied-page {
  display: grid;
  place-items: center;
}

.denied-panel {
  width: min(420px, 100%);
  border: 1px solid var(--design-border);
  border-radius: 8px;
  padding: 24px;
  background: #ffffff;
  box-shadow: var(--design-shadow);
  text-align: center;
}

.denied-panel p,
.denied-panel h1 {
  margin: 0;
}

.denied-panel p {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 850;
}

.denied-panel h1 {
  margin-top: 8px;
  font-size: 22px;
  font-weight: 850;
}

.denied-panel a {
  margin-top: 18px;
}

@media (max-width: 1180px) {
  .metrics-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
  .material-search-grid,
  .material-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .search-actions {
    grid-column: 1/-1;
  }
}
@media (max-width: 760px) {
  .materials-page {
    width: min(100% - 28px, 1360px);
    padding-top: 14px;
  }
  .materials-header,
  .access-summary,
  .panel-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .metrics-grid {
    grid-template-columns: 1fr;
  }
  .dashboard-panel {
    padding: 14px;
  }
  .panel-heading > span {
    white-space: normal;
  }
  .material-search-grid,
  .material-filter-grid {
    grid-template-columns: 1fr;
  }
  .search-actions {
    align-items: stretch;
    flex-direction: column;
  }
}
/* Review 159: compact material list and progressive search */
.unified-search,
.advanced-search,
.column-picker {
  margin-top: 12px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 13px 14px;
  background: #FFFFFF;
}

.unified-search > label,
.advanced-search summary,
.column-picker summary {
  color: #333333;
  font-size: 15px;
  font-weight: 600;
}

.unified-search > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  margin-top: 8px;
}

.unified-search input {
  width: 100%;
  min-height: 44px;
  border: 1px solid #BDBDBD;
  border-radius: 8px;
  padding: 0 12px;
  background: #FFFFFF;
}

.unified-search input:focus {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 3px rgba(43, 43, 43, 0.16);
  outline: none;
}

.unified-search button {
  min-width: 84px;
  border: 1px solid #2B2B2B;
  border-radius: 8px;
  padding: 0 16px;
  background: #2B2B2B;
  color: #FFFFFF;
  font-weight: 600;
}

.unified-search p,
.advanced-search > p,
.column-picker > p {
  margin: 7px 0 0;
  color: #666666;
  font-size: 14px;
}

.frequent-filters {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.advanced-search summary,
.column-picker summary {
  cursor: pointer;
}

.advanced-search .material-search-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 12px;
}

.advanced-search .search-actions {
  grid-column: 1/-1;
}

.column-picker > div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 10px;
}

.column-picker label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.filter-chip.removable {
  cursor: pointer;
  color: #333333;
}

.filter-chip.removable:hover,
.filter-chip.removable:focus-visible {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 3px rgba(43, 43, 43, 0.12);
}

.material-table {
  min-width: 1010px;
  table-layout: auto;
}

.material-table th:first-child,
.material-table .material-name-cell {
  min-width: 260px;
  width: 30%;
}

.material-table .contributor-cell {
  min-width: 170px;
}

.material-table .original-cell,
.material-table .review-cell {
  min-width: 170px;
}

.material-table .contributor-cell strong,
.material-table .contributor-cell span,
.material-table .original-cell strong,
.material-table .original-cell span,
.material-table .review-cell > span,
.material-table td > span + span {
  display: block;
  margin-top: 4px;
}

.material-table .contributor-cell strong,
.material-table .original-cell strong {
  color: #333333;
  font-weight: 600;
}

.material-table .contributor-cell span,
.material-table .original-cell span,
.material-table .review-cell > span {
  color: #666666;
  font-size: 13px;
}

@media (max-width: 1180px) {
  .frequent-filters {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .unified-search > div,
  .advanced-search .material-search-grid,
  .frequent-filters {
    grid-template-columns: 1fr;
  }
  .unified-search button,
  .advanced-search .search-actions,
  .advanced-search .search-actions button {
    width: 100%;
  }
  .material-table-scroll {
    max-width: 100%;
    overflow-x: auto;
  }
  .material-table {
    min-width: 930px;
  }
}
/* Review 157 common UI */
:host {
  background: #FFFFFF;
  color: #333333;
  font-size: 16px;
  line-height: 1.6;
}

:host h1,
:host h2,
:host h3,
:host strong {
  font-weight: 700;
}

:host p,
:host span,
:host label,
:host input,
:host select,
:host textarea,
:host button,
:host a,
:host th,
:host td,
:host small,
:host em {
  font-size: max(15px, 1em);
}

:host p,
:host span,
:host td,
:host small,
:host em {
  font-weight: 400;
}

:host label,
:host th,
:host button {
  font-weight: 600;
}

:host input,
:host select,
:host textarea {
  border-color: #D8D8D8;
  background: #FFFFFF;
  color: #333333;
}

:host input:focus,
:host select:focus,
:host textarea:focus {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 3px rgba(43, 43, 43, 0.16);
  outline: none;
}

:host button:disabled,
:host input:disabled,
:host select:disabled,
:host textarea:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

:host .table-scroll {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
}

:host table th,
:host table td {
  word-break: normal;
  overflow-wrap: break-word;
}

:host table th:first-child,
:host table td:first-child,
:host table th:last-child,
:host table td:last-child {
  white-space: nowrap;
}

:host .status-badge {
  font-size: 13px;
  font-weight: 600;
  word-break: keep-all;
  white-space: normal;
}

:host .notice,
:host .empty-cell,
:host .denied-panel {
  border-color: #D8D8D8;
  background: #F5F5F5;
}

:host .field-error {
  display: block;
  margin-top: 6px;
  color: #9A2A2A;
  font-size: 14px;
  font-weight: 600;
}

.materials-page {
  background: #FFFFFF;
}

.materials-header,
.dashboard-panel,
.metric-card,
.access-summary,
.data-basis {
  background: #FFFFFF;
  box-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
}

.access-summary,
.data-basis,
.filter-panel,
.list-basis {
  background: #F5F5F5;
}

.materials-header nav a:first-child,
.materials-header nav a[href="/admin/materials/new"],
.search-actions button:not(.secondary) {
  border-color: #2B2B2B;
  background: #2B2B2B;
  color: #FFFFFF;
}

.materials-header nav a:not(:first-child):not([href="/admin/materials/new"]),
.search-actions button.secondary,
.list-pagination button {
  border-color: #BDBDBD;
  background: #FFFFFF;
  color: #2B2B2B;
}

.material-table {
  min-width: 1180px;
}

.material-table .col-title {
  width: 260px;
}

.material-table .col-contributor {
  width: 180px;
}

.material-table .col-action {
  width: 96px;
}

.material-table td:nth-child(4),
.recent-table td:first-child {
  word-break: keep-all;
}

.manage-link {
  white-space: nowrap;
  color: #2B2B2B;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.data-basis > details,
.list-basis {
  width: 100%;
}

.data-basis summary,
.list-basis summary {
  cursor: pointer;
  font-weight: 600;
}

.type-bar i {
  background: #2B2B2B;
}

.materials-page p,
.materials-page span,
.materials-page a,
.materials-page label,
.materials-page input,
.materials-page select,
.materials-page textarea,
.materials-page td,
.materials-page small,
.materials-page em {
  font-size: 15px;
  font-weight: 400;
}

.materials-page h1,
.materials-page h2,
.materials-page h3,
.materials-page strong {
  font-weight: 700;
}

.materials-page button,
.materials-page label,
.materials-page th,
.materials-page .field-label {
  font-size: 15px;
  font-weight: 600;
}

.materials-page .status-badge {
  font-size: 13px;
  font-weight: 600;
}

/* Review 158 dashboard hierarchy */
.summary-section {
  margin-top: 12px;
}

.section-heading,
.access-status-summary,
.attention-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.section-heading {
  margin-bottom: 12px;
}

.section-heading p,
.section-heading h2,
.access-status-summary p,
.access-status-summary h3,
.attention-note,
.recent-basis {
  margin: 0;
}

.section-heading p,
.access-status-summary p {
  color: #666666;
}

.section-heading h2,
.access-status-summary h3 {
  margin-top: 3px;
  color: #222222;
  line-height: 1.25;
}

.section-heading h2 {
  font-size: 21px;
}

.access-status-summary h3 {
  font-size: 17px;
}

.section-heading > a,
.attention-heading > a,
.panel-link {
  color: #2B2B2B;
  font-weight: 600;
  text-underline-offset: 3px;
  white-space: nowrap;
}

.metrics-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.metric-card {
  min-height: 150px;
  border-color: #D8D8D8;
  padding: 17px;
  background: #FFFFFF;
}

.metric-card strong {
  margin-top: 10px;
  color: #222222;
  font-size: 30px;
  line-height: 1;
}

.metric-card em {
  min-height: 42px;
  color: #666666;
  line-height: 1.45;
}

.metric-card small,
.attention-card small {
  display: inline-block;
  margin-top: 9px;
  color: #2B2B2B;
  font-size: 13px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.status-needs_attention {
  border-color: #8D8D8D;
  background: #F5F5F5;
}

.access-status-summary {
  align-items: stretch;
  margin-top: 12px;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
  padding: 14px 16px;
  background: #F5F5F5;
}

.access-status-summary > div {
  flex: 1 1 auto;
}

.access-status-summary > button {
  min-width: 210px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 2px 14px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 10px 12px;
  background: #FFFFFF;
  color: #333333;
  cursor: pointer;
  text-align: left;
}

.access-status-summary > button:hover,
.access-status-summary > button:focus-visible,
.attention-card:hover,
.attention-card:focus-visible,
.topic-row:hover,
.topic-row:focus-visible {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 3px rgba(43, 43, 43, 0.14);
}

.access-status-summary > button strong {
  grid-column: 2;
  grid-row: 1;
  white-space: nowrap;
}

.access-status-summary > button em {
  grid-column: 1/-1;
  color: #666666;
  font-style: normal;
}

.attention-panel {
  margin-top: 18px;
  background: #F5F5F5;
}

.attention-note,
.recent-basis {
  color: #666666;
  line-height: 1.5;
}

.attention-note {
  margin-top: -2px;
}

.attention-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.attention-card {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 15px;
  background: #FFFFFF;
  color: #333333;
  cursor: pointer;
  text-align: left;
}

.attention-card > span {
  min-height: 48px;
  color: #333333;
  font-weight: 600;
  line-height: 1.45;
}

.attention-card > strong {
  margin-top: 6px;
  color: #222222;
  font-size: 24px;
  line-height: 1;
}

.reason-state-counts {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 5px 12px;
  margin-top: 11px;
  border-top: 1px solid #E8E8E8;
  padding-top: 9px;
}

.reason-state-counts em {
  color: #555555;
  font-size: 13px;
  font-style: normal;
}

.attention-card > p {
  min-height: 44px;
  margin: 8px 0 0;
  color: #666666;
  font-size: 14px;
  line-height: 1.45;
}

.attention-card > small {
  margin-top: auto;
  padding-top: 5px;
}

.recent-panel {
  margin-top: 18px;
}

.recent-basis {
  margin: -3px 0 11px;
}

.recent-table {
  min-width: 760px;
}

.recent-table td:first-child {
  width: 38%;
}

.reason-list {
  color: #444444;
  line-height: 1.45;
}

.panel-link {
  display: inline-block;
  margin-top: 12px;
}

.classification-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
  margin-top: 18px;
}

.topic-list {
  display: grid;
  gap: 8px;
}

.topic-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
  padding: 10px 12px;
  background: #FFFFFF;
  color: #333333;
  cursor: pointer;
  text-align: left;
}

.topic-row > span {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.topic-row em {
  color: #777777;
  font-size: 13px;
  font-style: normal;
}

.topic-row b {
  white-space: nowrap;
}

.overview-state {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 12px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 14px 16px;
  background: #F5F5F5;
}

.overview-state span {
  color: #666666;
}

.overview-state button {
  min-height: 36px;
  margin-left: auto;
  border: 1px solid #2B2B2B;
  border-radius: 8px;
  padding: 0 13px;
  background: #2B2B2B;
  color: #FFFFFF;
}

.partial-state {
  border-style: dashed;
}

.list-panel {
  margin-top: 12px;
}

.applied-filter-bar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px 12px;
  margin-bottom: 14px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 12px 14px;
  background: #F5F5F5;
}

.applied-filter-bar > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.filter-chip {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  border: 1px solid #BDBDBD;
  border-radius: 999px;
  padding: 2px 10px;
  background: #FFFFFF;
}

.applied-filter-bar > button {
  min-height: 36px;
  border: 1px solid #2B2B2B;
  border-radius: 8px;
  padding: 0 12px;
  background: #FFFFFF;
  color: #2B2B2B;
  white-space: nowrap;
}

.applied-filter-bar > p {
  grid-column: 1/-1;
  margin: 0;
  color: #666666;
  font-size: 14px;
}

@media (max-width: 1180px) {
  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .attention-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .classification-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 760px) {
  .section-heading,
  .access-status-summary,
  .attention-heading {
    align-items: stretch;
    flex-direction: column;
  }
  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .attention-grid {
    grid-template-columns: 1fr;
  }
  .metric-card,
  .attention-card {
    min-height: 0;
  }
  .metric-card em,
  .attention-card > span,
  .attention-card > p {
    min-height: 0;
  }
  .metric-card {
    padding: 13px;
  }
  .metric-card strong {
    font-size: 26px;
  }
  .metric-card em {
    font-size: 13px;
  }
  .access-status-summary > button {
    min-width: 0;
  }
  .applied-filter-bar {
    grid-template-columns: 1fr;
  }
  .applied-filter-bar > button {
    width: 100%;
  }
}
/* 159단계 최종 열 구성: 기본 6열은 좁은 화면에서도 표 내부에서만 스크롤 */
.material-table {
  min-width: 1010px;
  table-layout: auto;
}

@media (max-width: 760px) {
  .materials-page {
    width: min(100% - 20px, 1320px);
  }
  .material-table {
    min-width: 930px;
  }
  .unified-search > div,
  .advanced-search .material-search-grid,
  .frequent-filters {
    grid-template-columns: 1fr;
  }
}
/* Review 160: reason task list */
.review-task-table {
  min-width: 920px;
}

.review-task-table .reason-cell {
  min-width: 250px;
}

.review-task-table .reason-cell strong,
.review-task-table .reason-cell span,
.review-task-table .reason-cell small,
.review-task-table .review-cell span {
  display: block;
}

.review-task-table .reason-cell strong {
  color: #2B2B2B;
  font-size: 15px;
  font-weight: 700;
}

.review-task-table .reason-cell span,
.review-task-table .reason-cell small,
.review-task-table .review-cell span {
  margin-top: 4px;
  color: #666666;
  font-size: 13px;
  line-height: 1.45;
}

.review-task-table .manage-link {
  white-space: nowrap;
}`],
})
export class PageAdminMaterialsComponent implements OnInit {
    public metrics: DashboardMetric[] = [];
    public typeStats: MaterialTypeStat[] = [];
    public topicPurposeStats: any[] = [];
    public statusSummary: StatusSummaryItem[] = [];
    public attentionSummary: AttentionSummary = { uniqueCount: 0, reasonTotal: 0, reasons: [], note: "" };
    public recentItems: RecentMaterialItem[] = [];
    public recentBasis: string = "";
    public dataBasis: DataBasis | null = null;
    public overviewState: "initial" | "loading" | "complete" | "partial" | "failed" = "initial";
    public failedSections: string[] = [];
    public showListView: boolean = false;
    public showTaskList: boolean = false;
    public materialRows: MaterialListItem[] = [];
    public listFilters: MaterialListFilters = {
        query: "",
        title: "",
        contributor: "",
        materialId: "",
        keyword: "",
        source: "",
        materialType: "",
        accessLevel: "",
        reviewStatus: "",
        fulltext: "",
        registrationMethod: "",
        dashboardState: "",
        formatGroup: "",
        tagAxis: "",
        tagName: "",
        sort: "newest",
    };
    public listOptions: {
        materialTypes: OptionItem[],
        accessLevels: OptionItem[],
        reviewStatuses: OptionItem[],
        fulltextStates: OptionItem[],
        registrationMethods: OptionItem[],
    } = {
        materialTypes: [],
        accessLevels: [],
        reviewStatuses: [],
        fulltextStates: [],
        registrationMethods: [],
    };
    public listSummary: any = { total: 0, filtered: 0, shown: 0, page: 1, pageCount: 1, pageSize: 50, dataSource: "" };
    public listPage: number = 1;
    public listPageSize: number = 50;
    public listPageSizeOptions: number[] = [20, 50, 100];
    public loading: boolean = false;
    public listLoading: boolean = false;
    public accessDenied: boolean = false;
    public errorMessage: string = "";
    public listErrorMessage: string = "";
    public advancedSearchOpen: boolean = false;
    public extraColumns: any = {
        materialType: false,
        materialId: false,
        registrationMethod: false,
        detailStatus: false,
        lastModified: false,
    };
    public extraColumnOptions: any[] = [
        { key: "materialType", label: "자료 형식" },
        { key: "materialId", label: "자료ID" },
        { key: "registrationMethod", label: "등록 방식" },
        { key: "detailStatus", label: "세부 처리 상태" },
        { key: "lastModified", label: "수정일" },
    ];
    private listRequestToken: number = 0;
    private readonly listScrollKey: string = "admin-materials-list-context-v159";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.canAccessMaterials()) {
            this.accessDenied = true;
            this.errorMessage = "접근 권한이 없습니다.";
            await this.service.render();
            return;
        }
        this.restoreListStateFromUrl();
        if (this.showListView) {
            await this.loadMaterialList(false);
        } else {
            await this.loadOverview();
        }
        await this.service.render();
    }

    public async loadOverview() {
        this.loading = true;
        this.overviewState = "loading";
        this.errorMessage = "";
        await this.service.render();
        let response: any;
        try {
            response = await wiz.call("overview");
        } catch (e) {
            this.loading = false;
            this.overviewState = "failed";
            this.errorMessage = "관리 현황을 불러오지 못했습니다.";
            await this.service.render();
            return;
        }
        this.loading = false;
        if (response.code !== 200) {
            this.overviewState = "failed";
            this.errorMessage = this.responseMessage(response, "자료관리 대시보드를 불러오지 못했습니다.");
            await this.service.render();
            return;
        }
        this.metrics = response.data?.metrics || [];
        this.typeStats = response.data?.typeStats || [];
        this.topicPurposeStats = response.data?.topicPurposeStats || [];
        this.statusSummary = response.data?.statusSummary || [];
        this.attentionSummary = response.data?.attentionSummary || this.attentionSummary;
        this.recentItems = response.data?.recentItems || [];
        this.recentBasis = response.data?.recentBasis || "";
        this.dataBasis = response.data?.dataBasis || null;
        this.failedSections = response.data?.failedSections || [];
        this.overviewState = response.data?.aggregationStatus === "partial" ? "partial" : "complete";
        await this.service.render();
    }

    public async loadMaterialList(resetPage: boolean = true) {
        if (resetPage) this.listPage = 1;
        const requestToken = ++this.listRequestToken;
        this.listLoading = true;
        this.listErrorMessage = "";
        await this.service.render();

        let response: any;
        try {
            response = await wiz.call("material_list", {
                ...this.listFilters,
                viewMode: this.showTaskList ? "tasks" : "materials",
                page: this.listPage,
                pageSize: this.listPageSize
            });
        } catch (e) {
            if (requestToken !== this.listRequestToken) return;
            this.listLoading = false;
            this.listErrorMessage = "자료 목록을 불러오지 못했습니다. 기존 결과는 유지합니다.";
            await this.service.render();
            return;
        }

        if (requestToken !== this.listRequestToken) return;
        this.listLoading = false;
        if (response.code !== 200) {
            this.listErrorMessage = this.responseMessage(response, "자료 목록을 불러오지 못했습니다. 기존 결과는 유지합니다.");
            await this.service.render();
            return;
        }
        this.materialRows = response.data?.items || [];
        this.listOptions = response.data?.options || this.listOptions;
        this.listSummary = response.data?.summary || this.listSummary;
        this.listPage = Number(this.listSummary.page || this.listPage);
        this.listPageSize = Number(this.listSummary.pageSize || this.listPageSize);
        this.listFilters.sort = this.listSummary.sort || this.listFilters.sort;
        this.showTaskList = !!this.listSummary.taskMode;
        this.syncListStateUrl();
        await this.service.render();
        this.restoreListScroll();
    }

    public async resetMaterialListFilters() {
        this.showTaskList = false;
        this.listFilters = {
            query: "",
            title: "",
            contributor: "",
            materialId: "",
            keyword: "",
            source: "",
            materialType: "",
            accessLevel: "",
            reviewStatus: "",
            fulltext: "",
            registrationMethod: "",
            dashboardState: "",
            formatGroup: "",
            tagAxis: "",
            tagName: "",
            sort: "newest",
        };
        await this.loadMaterialList();
    }

    public async clearAppliedFilter(filter: any) {
        let key = String(filter?.key || "");
        if (!key) return;
        if (key === "tagName") {
            this.listFilters.tagAxis = "";
            this.listFilters.tagName = "";
        } else if (Object.prototype.hasOwnProperty.call(this.listFilters, key)) {
            (this.listFilters as any)[key] = "";
        }
        await this.loadMaterialList(true);
    }

    public async toggleExtraColumn(key: string) {
        if (!Object.prototype.hasOwnProperty.call(this.extraColumns, key)) return;
        this.extraColumns[key] = !this.extraColumns[key];
        this.syncListStateUrl();
        await this.service.render();
    }

    public visibleColumnCount(): number {
        if (this.showTaskList) return 5;
        return 6 + Object.values(this.extraColumns).filter((value) => !!value).length;
    }

    public async applyMetric(metric: DashboardMetric) {
        let state = metric.filterKey === "total" ? "" : metric.filterKey;
        await this.openListView(state, state === "needs_attention");
    }

    public async applyStatus(item: StatusSummaryItem) {
        await this.openListView(item.filterKey);
    }

    public async applyAttention(reason: AttentionReason) {
        await this.openListView(reason.filterKey, true);
    }

    private async openListView(dashboardState: string = "", taskMode: boolean = false) {
        this.showListView = true;
        this.showTaskList = taskMode;
        this.listFilters.dashboardState = dashboardState;
        this.listFilters.formatGroup = "";
        this.listFilters.tagAxis = "";
        this.listFilters.tagName = "";
        this.syncListStateUrl();
        await this.loadMaterialList(true);
        window.scrollTo({ top: 0, behavior: "auto" });
    }

    public async applyFormat(item: MaterialTypeStat) {
        this.showListView = true;
        this.showTaskList = false;
        this.listFilters.formatGroup = item.key;
        this.listFilters.dashboardState = "";
        this.listFilters.tagAxis = "";
        this.listFilters.tagName = "";
        this.syncListStateUrl();
        await this.loadMaterialList(true);
        window.scrollTo({ top: 0, behavior: "auto" });
    }

    public async applyTopic(item: any) {
        this.showListView = true;
        this.showTaskList = false;
        this.listFilters.dashboardState = "";
        this.listFilters.formatGroup = "";
        this.listFilters.tagAxis = item.axis || "";
        this.listFilters.tagName = item.label || "";
        this.syncListStateUrl();
        await this.loadMaterialList(true);
        window.scrollTo({ top: 0, behavior: "auto" });
    }

    public async changeListPage(delta: number) {
        await this.goToListPage(this.listPage + delta);
    }

    public async goToListPage(page: number) {
        let next = Math.max(1, Math.min(Number(this.listSummary.pageCount || 1), Number(page || 1)));
        if (next === this.listPage && this.materialRows.length > 0) return;
        this.listPage = next;
        await this.loadMaterialList(false);
        document.getElementById("material-list")?.scrollIntoView({ behavior: "auto", block: "start" });
    }

    public async changeListPageSize() {
        this.listPageSize = this.listPageSizeOptions.includes(Number(this.listPageSize))
            ? Number(this.listPageSize)
            : 50;
        await this.loadMaterialList(true);
    }

    public listRangeLabel(): string {
        let filtered = Number(this.listSummary?.filtered || 0);
        if (filtered <= 0) return this.showTaskList ? "확인할 고유 자료 0건입니다." : "전체 0건 중 표시할 자료가 없습니다.";
        if (this.showTaskList) {
            let tasks = Number(this.listSummary?.taskCount || this.listSummary?.rowTotal || 0);
            return `고유 자료 ${filtered}건 · 사유별 업무 ${tasks}건 중 ${this.listSummary.from}–${this.listSummary.to}건`;
        }
        return `전체 ${filtered}건 중 ${this.listSummary.from}–${this.listSummary.to}건`;
    }

    private restoreListStateFromUrl() {
        let params = new URLSearchParams(window.location.search || "");
        let fields: Array<[keyof MaterialListFilters, string]> = [
            ["query", "query"],
            ["title", "title"], ["contributor", "contributor"], ["materialId", "materialId"],
            ["keyword", "keyword"], ["source", "source"], ["materialType", "materialType"],
            ["accessLevel", "accessLevel"], ["reviewStatus", "reviewStatus"], ["fulltext", "fulltext"],
            ["registrationMethod", "registrationMethod"], ["dashboardState", "dashboardState"],
            ["formatGroup", "formatGroup"], ["tagAxis", "tagAxis"], ["tagName", "tagName"],
        ];
        fields.forEach(([field, key]) => this.listFilters[field] = params.get(key) || "");
        this.showTaskList = params.get("view") === "tasks";
        this.showListView = params.get("view") === "list" || this.showTaskList || fields.some(([, key]) => params.has(key)) || params.has("page") || params.has("pageSize") || params.has("sort");
        let sort = params.get("sort") || "newest";
        this.listFilters.sort = ["newest", "oldest", "title", "title-desc"].includes(sort) ? sort : "newest";
        let pageSize = Number(params.get("pageSize") || 50);
        this.listPageSize = this.listPageSizeOptions.includes(pageSize) ? pageSize : 50;
        this.listPage = Math.max(1, Number(params.get("page") || 1));
        let columns = (params.get("columns") || "").split(",").filter((item) => !!item);
        Object.keys(this.extraColumns).forEach((key) => this.extraColumns[key] = columns.includes(key));
        this.advancedSearchOpen = ["title", "contributor", "materialId", "keyword", "source", "registrationMethod"]
            .some((key) => params.has(key));
    }

    private syncListStateUrl() {
        let params = new URLSearchParams();
        let fields: Array<[keyof MaterialListFilters, string]> = [
            ["query", "query"],
            ["title", "title"], ["contributor", "contributor"], ["materialId", "materialId"],
            ["keyword", "keyword"], ["source", "source"], ["materialType", "materialType"],
            ["accessLevel", "accessLevel"], ["reviewStatus", "reviewStatus"], ["fulltext", "fulltext"],
            ["registrationMethod", "registrationMethod"], ["dashboardState", "dashboardState"],
            ["formatGroup", "formatGroup"], ["tagAxis", "tagAxis"], ["tagName", "tagName"],
        ];
        fields.forEach(([field, key]) => {
            let value = String(this.listFilters[field] || "").trim();
            if (value) params.set(key, value);
        });
        if (this.showListView) params.set("view", this.showTaskList ? "tasks" : "list");
        if (this.listFilters.sort !== "newest") params.set("sort", this.listFilters.sort);
        if (this.listPage > 1) params.set("page", String(this.listPage));
        if (this.listPageSize !== 50) params.set("pageSize", String(this.listPageSize));
        let columns = Object.keys(this.extraColumns).filter((key) => !!this.extraColumns[key]);
        if (columns.length) params.set("columns", columns.join(","));
        let query = params.toString();
        let target = `/admin/materials${query ? "?" + query : ""}`;
        if (`${window.location.pathname}${window.location.search}` !== target) {
            window.history.replaceState({ page: this.listPage }, "", target);
        }
    }

    public responseMessage(response: any, fallback: string): string {
        let data = response?.data;
        if (typeof data === "string") return data;
        if (data?.message) return data.message;
        return fallback;
    }

    public currentUserName(): string {
        return this.service.auth.session?.name || this.service.auth.session?.username || "";
    }

    public isAdmin(): boolean {
        return this.service.auth.session?.status === "active" && this.service.auth.session?.role === "admin";
    }

    public materialPermissions(): string[] {
        let value = this.service.auth.session?.materialsPermissions || this.service.auth.session?.materials_permissions || [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim()) {
            try {
                let parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return parsed;
            } catch (e) {
                return value.split(",").map((item) => item.trim()).filter((item) => !!item);
            }
        }
        return [];
    }

    public canAccessMaterials(): boolean {
        let session = this.service.auth.session || {};
        return session.status === "active" && (["admin", "materials"].includes(session.role) || this.materialPermissions().length > 0);
    }

    public canRegisterMaterials(): boolean {
        let session = this.service.auth.session || {};
        let permissions = this.materialPermissions();
        return session.status === "active" && (
            session.role === "admin" ||
            session.role === "materials" ||
            permissions.includes("materials_admin") ||
            permissions.includes("materials_register")
        );
    }

    public maxTypeCount(): number {
        let values = this.typeStats.map((item) => item.count || 0);
        return Math.max(1, ...values);
    }

    public typeBarWidth(item: MaterialTypeStat): string {
        let width = Math.round(((item.count || 0) / this.maxTypeCount()) * 100);
        return `${Math.max(2, width)}%`;
    }

    public materialDetailUrl(item: any): string {
        if (!item?.id) return "/admin/materials";
        let returnTo = `${window.location.pathname}${window.location.search}`;
        let params = new URLSearchParams();
        if (item?.reasonKey) {
            params.set("tab", "review");
            params.set("reason", String(item.reasonKey));
        }
        params.set("returnTo", returnTo);
        return `/admin/materials/detail/${encodeURIComponent(item.id)}?${params.toString()}`;
    }

    public prepareDetailNavigation() {
        try {
            sessionStorage.setItem(this.listScrollKey, JSON.stringify({
                url: `${window.location.pathname}${window.location.search}`,
                scrollY: Math.max(0, Math.round(window.scrollY || 0)),
            }));
        } catch (e) { }
    }

    private restoreListScroll() {
        if (!this.showListView) return;
        try {
            let saved = JSON.parse(sessionStorage.getItem(this.listScrollKey) || "{}");
            let current = `${window.location.pathname}${window.location.search}`;
            if (saved.url !== current || !Number.isFinite(Number(saved.scrollY))) return;
            let restore = () => window.scrollTo({ top: Number(saved.scrollY), behavior: "auto" });
            requestAnimationFrame(restore);
            setTimeout(restore, 120);
            setTimeout(restore, 360);
        } catch (e) { }
    }

    @HostListener('window:popstate')
    public async handlePopState() {
        this.restoreListStateFromUrl();
        if (this.showListView) await this.loadMaterialList(false);
        else await this.loadOverview();
    }

    public displayTerm(value: any): string {
        let text = value === null || value === undefined ? "" : `${value}`;
        const exact: any = {
            "내부열람": "내부 사용자만 열람",
            "검수 대기": "자료 확인 필요",
            "검수대기": "자료 확인 필요",
            "검수 완료": "자료 확인 완료",
            "검수완료": "자료 확인 완료",
            "태그추천대기": "주제어 확인 필요",
            "본문근거연결대기": "본문 근거 연결 확인 필요",
            "OCR 필요": "이미지 속 글자 인식 필요"
        };
        if (exact[text]) return exact[text];
        return text
            .replace(/서지DB/g, "자료 기본정보")
            .replace(/원문DB/g, "원문 파일")
            .replace(/메타데이터/g, "자료 정보")
            .replace(/본문색인/g, "본문 검색")
            .replace(/청크/g, "본문 구간")
            .replace(/지식그래프/g, "자료 관계도")
            .replace(/노드/g, "항목")
            .replace(/태그/g, "주제어")
            .replace(/검수/g, "자료 확인")
            .replace(/내부열람/g, "내부 사용자만 열람")
            .replace(/OCR/g, "이미지 속 글자 인식");
    }

    public statusClass(value: string): string {
        let text = (value || "").replace(/\s+/g, "");
        if (text === "공개") return "is-public";
        if (text === "내부열람") return "is-internal";
        if (text === "공개보류") return "is-hold";
        if (text === "비공개") return "is-private";
        if (text === "검수대기") return "is-review-pending";
        if (text === "검수완료") return "is-review-complete";
        if (text === "등록초안") return "is-draft";
        if (text.includes("보류") || text.includes("보완") || text.includes("필요") || text.includes("미보유") || text.includes("반려")) return "is-hold";
        if (text.includes("대기") || text.includes("요청")) return "is-review-pending";
        if (text.includes("완료") || text.includes("확보") || text.includes("연결") || text.includes("색인")) return "is-complete";
        if (text.includes("내부")) return "is-internal";
        return "is-muted";
    }

    public trackMetric(index: number, item: DashboardMetric) {
        return item.label || index;
    }

    public trackType(index: number, item: MaterialTypeStat) {
        return item.key || index;
    }

    public trackStatus(index: number, item: StatusSummaryItem) {
        return item.label || index;
    }

    public trackReason(index: number, item: AttentionReason) {
        return item.key || index;
    }

    public trackTopic(index: number, item: any) {
        return `${item.axis || ""}:${item.label || index}`;
    }

    public trackRecent(index: number, item: RecentMaterialItem) {
        return item.id || item.title || index;
    }

    public trackMaterial(index: number, item: MaterialListItem) {
        return `${item.id || item.title || index}:${item.reasonKey || ""}`;
    }
}

export default PageAdminMaterialsComponent;